import { ReactComponent as UserGroup } from 'assets/svg/3 User.svg';
import { ReactComponent as Activity } from 'assets/svg/Activity.svg';
import { ReactComponent as AddUser } from 'assets/svg/Add User.svg';
import { ReactComponent as Category } from 'assets/svg/Category.svg';
import { ReactComponent as Message } from 'assets/svg/Message.svg';
import { ReactComponent as Notification } from 'assets/icons/sidebarlocation.svg';
import { ReactComponent as Taskicon } from 'assets/svg/Taskicon.svg';
import { ReactComponent as Question } from 'assets/svg/Question.svg';
import { ReactComponent as Pipelinemenu } from 'assets/svg/Pipelinemenu.svg';
import { ReactComponent as Pipelineactivemenu } from 'assets/svg/Pipelinemenuactive.svg';

export const MENU = {
  all_users: [
    {
      menu_name: 'Dashboard',
      menu_icon: <Category width={23} height={23} />,
      active_menu_icon: <Category width={23} height={23} />,
      link: '/dashboard',
    },
    {
      menu_name: 'Messaging',
      menu_icon: <Message width={23} height={23} />,
      active_menu_icon: <Message width={23} height={23} />,
      // REMOVE link to prevent navigation
      link: '/message',
    },
    {
      menu_name: 'Tasks',
      menu_icon: <Taskicon width={23} height={23} />,
      active_menu_icon: <Taskicon width={23} height={23} />,
      link: '/tasks',
    },
    {
      menu_name: 'Contacts',
      menu_icon: <UserGroup width={23} height={23} />,
      active_menu_icon: <UserGroup width={23} height={23} />,
      link: '/People',
    },

    {
      menu_name: 'Pipeline',
      menu_icon: <Pipelinemenu width={23} height={23} />,
      active_menu_icon: <Pipelineactivemenu width={23} height={23} />,
      link: '/pipeline',
    },

    {
      menu_name: 'Insights',
      menu_icon: <Activity width={23} height={23} />,
      active_menu_icon: <Activity width={23} height={23} />,
      link: '/insights',
    },
    {
      menu_name: 'Marketplace',
      menu_icon: <Notification width={23} height={23} />,
      active_menu_icon: <Notification width={23} height={23} />,
      link: '/landingpage',
    },
    {
      menu_name: 'Help',
      menu_icon: <Question width={23} height={23} />,
      active_menu_icon: <Question width={23} height={23} />,
      link: '/helpcentre',
    },
    {
      menu_name: 'Invite',
      menu_icon: <AddUser width={23} height={23} />,
      active_menu_icon: <AddUser width={23} height={23} />,
      link: '/invite',
    },
  ],
};
